import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { ApplianceDebuggerApiRef } from './api/ApplianceDebuggerApi';
import { ApplianceDebuggerClient } from './api/ApplianceDebuggerClient';

export const applianceDebuggerPlugin = createPlugin({
  id: 'appliance-debugger',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: ApplianceDebuggerApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new ApplianceDebuggerClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const ApplianceDebuggerPage = applianceDebuggerPlugin.provide(
  createRoutableExtension({
    name: 'ApplianceDebuggerPage',
    component: () => import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
